// @flow

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import ScalableMedia from 'ScalableMedia';

class Home extends PureComponent {
  static defaultProps = {
    entityLabel: '',
    // fieldMetaTags: '',
    fieldFile: '',
    fieldFile2: '',
  };

  static propTypes = {
    entityLabel: PropTypes.string.isRequired,
    // fieldMetaTags: PropTypes.string.isRequired,
    fieldFile: PropTypes.string.isRequired,
    fieldFile2: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.mq = false;
    this.introVideo = false;

    this.state = {
      isTablet: false,
    };
  }

  componentDidMount() {
    this.mountIntroVideo();

    // Remove the videos if viewed on tablet or mobile screen.
    if (this.mq === false) {
      this.mq = global.matchMedia('(max-width: 768px)');
      this.mqChange(this.mq);
      this.mq.addListener(this.mqChange.bind(this));
    }

    // If this is being mounted and the intro is already finished don't play it.
    if (this.props.introFinished) {
      global.document.documentElement.classList.add('js-no-intro-animation');
      this.div.querySelectorAll('.site-content__bg-video video')[0].play();
    }
  }

  componentWillReceiveProps(nextProps) {
    // The intro animation will only play once so this function will only be
    // called once.
    if (nextProps.introFinished) {
      global.document.documentElement.classList.add('js-play-intro-animation');
      this.div.querySelectorAll('.site-content__bg-video video')[0].play();
    }
  }

  componentDidUpdate() {
    this.mountIntroVideo();
  }

  componentWillUnmount() {
    this.unmountIntroVideo();

    if (this.mq) {
      this.mq.removeListener(this.mqChange.bind(this));
      this.mq = false;
    }

    if (this.firstItem) {
      this.firstItem.classList.remove('is-active');
      this.firstItem = null;
    }
  }

  mountIntroVideo() {
    // Set up the intro video variable and listener.
    if (this.introVideo === false) {
      const videos = this.div.querySelectorAll('.site-content__hero video');
      if (videos.length) {
        this.introVideo = videos[0];
        this.introVideo.addEventListener(
          'ended',
          this.introVideoEnded.bind(this),
          true,
        );

        // Check if autoplay worked...
        // https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
        const promise = this.introVideo.play();
        if (promise !== undefined) {
          promise
            .then(() => {
              // Autoplay started!
              this.props.setIntroFinished(false);
            })
            .catch(() => {
              // Autoplay was prevented.
            });
        } else {
          // Assume autoplay started on browsers without promises returned.
          this.props.setIntroFinished(false);
        }
      }
    }

    if (this.props.introFinished) {
      // Don't play the video in the background if the intro is finished.
      if (this.introVideo) {
        this.introVideo.removeAttribute('preload');
        this.introVideo.removeAttribute('autoplay');
        this.introVideo.pause();
      }

      // Mark the first item as active to help the user out on desktop.
      if (!this.state.isTablet) {
        const firstItem = global.document.querySelectorAll(
          '.wheel__nav-item:first-child > a',
        )[0];

        this.firstItem = firstItem;
        this.firstItem.classList.add('is-active');
      }
    }
  }

  unmountIntroVideo() {
    if (this.introVideo) {
      // Do not show the intro video again if someone navigates away from the
      // home page before the intro video finishes.
      this.props.setIntroFinished(true);
      this.introVideo.removeEventListener(
        'ended',
        this.introVideoEnded.bind(this),
      );
      this.introVideo = false;
    }
  }

  mqChange(mq) {
    if (this.state.isTablet !== mq.matches) {
      if (mq.matches) {
        global.document.documentElement.classList.add('js-no-intro-animation');
        this.unmountIntroVideo();
      }

      this.setState({
        isTablet: mq.matches,
      });
    }
  }

  introVideoEnded() {
    this.props.setIntroFinished(true);
  }

  /* eslint-disable react/no-danger */
  render() {
    const isHidden = this.props.introFinished ? ' is-hidden' : '';

    return (
      <main
        ref={ref => {
          this.div = ref;
        }}
        className="site-content"
      >
        <Helmet defaultTitle={this.props.entityLabel}>
          <meta property="og:title" content={this.props.entityLabel} />
          <meta
            name="description"
            content="Disrupting the frame with stories of action, courage, and transformation"
          />
          <meta
            property="og:description"
            content="Disrupting the frame with stories of action, courage, and transformation"
          />
        </Helmet>
        <h1 className="visually-hidden">
          {this.props.entityLabel}
        </h1>
        {this.state.isTablet
          ? ''
          : <ScalableMedia
            className={`site-content__hero site-content__screen site-content__screen--fixed hide-on-mobile js-scale-media-container${isHidden}`}
          >
            {this.props.fieldFile}
          </ScalableMedia>}
        {this.state.isTablet
          ? ''
          : <ScalableMedia className="site-content__bg-video site-content__screen site-content__screen--fixed hide-on-mobile js-scale-media-container">
            {this.props.fieldFile2}
          </ScalableMedia>}
      </main>
    );
  }
  /* eslint-enable react/no-danger */
}

const introHasFinished = (bool: Boolean = false) => ({
  type: 'INTRO_FINISHED',
  isPlaying: !bool,
  hasFinished: bool,
});

const mapStateToProps = state => ({
  introPlaying: state.intro.isPlaying,
  introFinished: state.intro.hasFinished,
});

const mapDispatchToProps = dispatch => ({
  setIntroFinished: bool => dispatch(introHasFinished(bool)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);



// WEBPACK FOOTER //
// ./screens/App/screens/Home/Home.js